import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/lib/LanguageContext";
import RouteTransition from "@/components/RouteTransition";
import HomePage from "@/pages/HomePage";
import ListingsPage from "@/pages/ListingsPage";
import ListingDetailPage from "@/pages/ListingDetailPage";
import BookingSuccessPage from "@/pages/BookingSuccessPage";
import ContactPage from "@/pages/ContactPage";
import RecommendationsPage from "@/pages/RecommendationsPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import CheckoutRedirectPage from "@/pages/CheckoutRedirectPage";

function App() {
  return (
    <LanguageProvider>
      <HelmetProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <RouteTransition>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/unterkuenfte" element={<ListingsPage />} />
              <Route path="/unterkunft/:id" element={<ListingDetailPage />} />
              <Route path="/buchung/erfolg" element={<BookingSuccessPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/empfehlungen" element={<RecommendationsPage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="/checkout/:listingId" element={<CheckoutRedirectPage />} />
            </Routes>
          </RouteTransition>
        </BrowserRouter>
      </HelmetProvider>
    </LanguageProvider>
  );
}

export default App;
